import React from "react";

export default function JBIcon({ style, className }: any) {
  return (
    <svg className={className} height="20" viewBox="0 0 58.56 32.42">
      <path
        className="j"
        d="M27.76,23.73a8.07,8.07,0,0,1-.57,3.05,7.3,7.3,0,0,1-1.59,2.45,7.12,7.12,0,0,1-2.43,1.61,8,8,0,0,1-3.08.58H0V25.94H20.09a2.11,2.11,0,0,0,1.58-.58,2.22,2.22,0,0,0,.57-1.63V1.19h5.52Z"
      />
      <path
        className="b"
        d="M58.56,24.73a8,8,0,0,1-.18,1.64,8.59,8.59,0,0,1-.55,1.72,7.89,7.89,0,0,1-1,1.63,6.58,6.58,0,0,1-1.45,1.38,6.82,6.82,0,0,1-2,1,8.27,8.27,0,0,1-2.53.36H41a8.43,8.43,0,0,1-3.36-.74,7.84,7.84,0,0,1-1.63-1,6.58,6.58,0,0,1-1.38-1.45,7.29,7.29,0,0,1-1-2,8.33,8.33,0,0,1-.36-2.54V0h5.48V24.73a2.12,2.12,0,0,0,.63,1.61,2.21,2.21,0,0,0,1.58.6h9.89a2.09,2.09,0,0,0,1.61-.61,2.22,2.22,0,0,0,.58-1.6V17.31a2.13,2.13,0,0,0-.61-1.62,2.23,2.23,0,0,0-1.58-.58H41V9.63h9.89a8,8,0,0,1,1.64.18,8.63,8.63,0,0,1,1.72.56,7.91,7.91,0,0,1,1.64,1,6.59,6.59,0,0,1,1.37,1.46,7.51,7.51,0,0,1,1,2,8.55,8.55,0,0,1,.35,2.53Z"
      />
    </svg>
  );
}
